import React, { useEffect, useState } from "react";
import AceEditor from "react-ace";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-dawn";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
import { getAceEditorTheme } from "../../../../../../../common/utils/aceEditorTheme";

const ScriptVariableValue = ({ scriptedVariable }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(scriptedVariable.script);

  const onChangeScript = (e) => {
    setValue(e);
    scriptedVariable.script = e;
    dispatch(setEditorSaved(false));
  };

  return (
    <AceEditor
      className="ihub-script-var-editor"
      mode="javascript"
      theme={getAceEditorTheme()}
      name="code"
      editorProps={{ $blockScrolling: true }}
      value={value}
      onChange={onChangeScript}
      height="300px"
      width="100%"
      showPrintMargin={false}
    />
  );
};

export default ScriptVariableValue;
